/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
export class SecurityGroupsApi extends BaseApi {
    getSecurityGroups(opts) {
        return this.get({
            path: '/security-groups',
            queryParams: opts
        });
    }
    createSecurityGroup(securityGroupBody, opts) {
        return this.post({
            path: '/security-groups',
            queryParams: opts,
            bodyParam: securityGroupBody
        });
    }
    getSecurityGroupInfo(securityGroupId, opts) {
        const pathParams = {
            securityGroupId
        };
        return this.get({
            path: '/security-groups/{securityGroupId}',
            pathParams,
            queryParams: opts
        });
    }
    updateSecurityGroup(securityGroupId, securityGroupBody, opts) {
        const pathParams = {
            securityGroupId
        };
        return this.put({
            path: '/security-groups/{securityGroupId}',
            pathParams,
            queryParams: opts,
            bodyParam: securityGroupBody
        });
    }
    deleteSecurityGroup(securityGroupId) {
        const pathParams = { securityGroupId };
        return this.delete({
            path: '/security-groups/{securityGroupId}',
            pathParams
        });
    }
}
